import React from 'react';
import { AiFillLinkedin, AiFillTwitterSquare, AiFillYoutube, AiFillGithub } from 'react-icons/ai'; // Import social media icons
import logo from '../../img/logo/logo.png'; // Import your logo image
import './footer.css';

const Footer = () => {
  return (
    <div className="pg-footer">
      <footer className="footer">
        {/* Add a decorative wave SVG */}
        <svg className="footer-wave-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 100" preserveAspectRatio="none">
          <path className="footer-wave-path" fill="url(#waveGradient)" d="M851.8,100c125,0,288.3-45,348.2-64V0H0v44c3.7-1,7.3-1.9,11-2.9C80.7,22,151.7,10.8,223.5,6.3C276.7,2.9,330,4,383,9.8 c52.2,5.7,103.3,16.2,153.4,32.8C623.9,71.3,726.8,100,851.8,100z"></path>
          <defs>
            <linearGradient id="waveGradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" style={{ stopColor: "#ad0000" }} />
              <stop offset="100%" style={{ stopColor: "#ad0000" }} />
            </linearGradient>
          </defs>
        </svg>
        <div className="footer-content">
          {/* Add your logo */}
          <img src={logo} alt="Company Logo" className="footer-logo" />
          
        </div>
        <div className="footer-copyright">
        <p className="footer-copyright-text">
    {/* Update copyright information */}
    © 2024 All Rights Reserved Wazir Mubashir Hussain
</p>
        </div>
      </footer>
    </div>
  );
}

export default Footer;